/* eslint-disable no-undef */
import PlayerEvent from '../../events/player.event';
import * as AdEvents from '../../events/ad.events';
import { logDebugging } from '../../../log/logger';

export default class YoutubePlayerListeners {
  constructor(playerYoutube) {
    this.playerYoutube = playerYoutube;
    this.isActivateListeners = false;
    this.isFirstStart = false;
    this.youtubePlayerEvent = new PlayerEvent('onYoutubePlayerEvent');
    this.addHandlers();
  }

  addHandlers() {
    let done = false;
    try {
      if (this.playerYoutube != null) {
        this.playerYoutube.addEventListener(
          'onReady',
          (event) => {
            logDebugging('[YoutubePlayerListeners] youtube onReady ');
            this.isActivateListeners = true;
            // setTimeout(() => {
            //   document.querySelector('.tpx-youtube-container').style.display = 'block';
            // }, 1000);

            if (event.data == null) {
              this.dispatchEvent([
                AdEvents.AdLoaded,
                this.playerYoutube.getCurrentTime(),
                this.playerYoutube.getDuration(),
              ]);

              event.target.addEventListener(
                'onStateChange',
                (evt) => {
                  if (document.querySelector('.video-external-link'))
                    document.querySelector('.video-external-link').style.display = 'none';
                  logDebugging(`[YoutubePlayerListeners] youtube onStateChange ${evt.data}`);
                  if (
                    (evt.data === YT.PlayerState.PLAYING ||
                      evt.data === YT.PlayerState.BUFFERING) &&
                    !done
                  ) {
                    this.dispatchEvent([
                      AdEvents.AdStarted,
                      this.playerYoutube.getCurrentTime(),
                      this.playerYoutube.getDuration(),
                    ]);
                    this.intervalTime = setInterval(() => {
                      this.dispatchEvent([
                        AdEvents.AdRemainingTimeChange,
                        this.playerYoutube.getCurrentTime(),
                        this.playerYoutube.getDuration(),
                      ]);
                    }, 500);
                    done = true;
                    // this.showCoverYoutube('block');
                  } else if (evt.data === YT.PlayerState.ENDED) {
                    clearInterval(this.intervalTime);

                    this.dispatchEvent([
                      AdEvents.AdStopped,
                      this.playerYoutube.getCurrentTime(),
                      this.playerYoutube.getDuration(),
                    ]);
                    done = false;
                  } else if (evt.data === YT.PlayerState.PAUSED) {
                    clearInterval(this.intervalTime);
                    if (this.playerYoutube.getCurrentTime() < this.playerYoutube.getDuration())
                      this.dispatchEvent([
                        AdEvents.AdPaused,
                        this.playerYoutube.getCurrentTime(),
                        this.playerYoutube.getDuration(),
                      ]);
                  } else if (evt.data === YT.PlayerState.PLAYING) {
                    clearInterval(this.intervalTime);
                    this.intervalTime = setInterval(() => {
                      this.dispatchEvent([
                        AdEvents.AdRemainingTimeChange,
                        this.playerYoutube.getCurrentTime(),
                        this.playerYoutube.getDuration(),
                      ]);
                    }, 500);
                    this.dispatchEvent([
                      AdEvents.AdPlaying,
                      this.playerYoutube.getCurrentTime(),
                      this.playerYoutube.getDuration(),
                    ]);
                  } else if (evt.data === -1) {
                    clearInterval(this.intervalTime);
                    this.dispatchEvent([
                      AdEvents.AdPlayError,
                      this.playerYoutube.getCurrentTime(),
                      this.playerYoutube.getDuration(),
                    ]);
                    // this.showCoverYoutube('none');
                  }
                },
                false,
              );
              event.target.addEventListener(
                'onError',
                (err) => {
                  logDebugging('[YoutubePlayerListeners]  onError ');
                  logDebugging(err);
                  logDebugging(err.target.playerInfo.videoEmbedCode);
                  logDebugging(err.target.playerInfo.debugText);
                  this.dispatchEvent([AdEvents.AdError, err.target.playerInfo.videoEmbedCode]);
                },
                false,
              );
              event.target.addEventListener(
                'onPlaybackQualityChange',
                (evt) => {
                  this.dispatchEvent([AdEvents.ONQUALITYCHANGE, evt.data]);
                },
                false,
              );
            }
          },
          false,
        );

        this.playerYoutube.addEventListener(
          '',
          function onSpotClickThrough() {
            this.dispatchEvent([
              AdEvents.AdError,
              this.playerYoutube.getCurrentTime(),
              this.playerYoutube.getDuration(),
            ]);
          },
          false,
        );
      }
    } catch (error) {
      logDebugging(error);
    }
  }

  skip() {
    this.dispatchEvent([
      AdEvents.AdSkipped,
      this.playerYoutube.getCurrentTime(),
      this.playerYoutube.getDuration(),
    ]);
  }

  replay() {
    this.dispatchEvent([
      AdEvents.AdReplay,
      this.playerYoutube.getCurrentTime(),
      this.playerYoutube.getDuration(),
    ]);
  }

  clearIntervalTime() {
    clearInterval(this.intervalTime);
  }

  dispatchEvent(arg) {
    this.youtubePlayerEvent.fire(this, { message: arg });
  }

  /**
   * para evitar que el player en autoplay sin policy pueda pulsarse, hay que quitar el cover para poder hacer click en el video de youtube
   * chrome://flags/#autoplay-policy
   * */
  // showCoverYoutube(show) {
  //     if (document.getElementById(this.idComponent).querySelector('.video-player-cover.youtube')) {
  //       document
  //         .getElementById(this.idComponent)
  //         .querySelector('.video-player-cover.youtube').style.display = show;
  //     }
  //     if (document.getElementById(this.idComponent).querySelector('.play-wrapper')) {
  //       if (
  //         show === 'block' &&
  //         document
  //           .getElementById(this.idComponent)
  //           .querySelector('.play-wrapper')
  //           .classList.contains('hide')
  //       ) {
  //         document
  //           .getElementById(this.idComponent)
  //           .querySelector('.play-wrapper')
  //           .classList.remove('hide');
  //       }
  //       if (show === 'none') {
  //         document
  //           .getElementById(this.idComponent)
  //           .querySelector('.play-wrapper')
  //           .classList.add('hide');
  //       }
  //     }
  // }
}
